import defaultAttributes from '../defaultAttributes';

const Code2 = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm18 16 4-4-4-4' }],
    ['path', { d: 'm6 8-4 4 4 4' }],
    ['path', { d: 'm14.5 4-5 16' }],
  ],
];

export default Code2;
